import React, { ReactElement, FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Tag, Typography } from 'antd'
import { ExpandingCard } from '../../../../../Components/UI'
import { formatCost } from '../../../../../Utilities'
import { s } from './style'
import { BookingEnquiryDetailsEventFragment } from './EnqiuryDetails.generated-types'

const { Paragraph, Text } = Typography

interface EnquiryDetailsProps {
  canExpand: boolean
  defaultExpanded: boolean
  event: BookingEnquiryDetailsEventFragment
}

export const EnquiryDetails: FC<EnquiryDetailsProps> = ({
  canExpand,
  defaultExpanded,
  event: { attendees, budget, location, currency, cateringNeeds, additionalNotes, spaceFacilities },
}): ReactElement => {
  const { t } = useTranslation()

  return (
    <div style={s.root}>
      <ExpandingCard
        title={t('eventHub.inProgress.details.header', 'Enquiry details')}
        canExpand={canExpand}
        defaultExpanded={defaultExpanded}>
        <>
          <div style={s.details}>
            {location && (
              <>
                <Text style={{ gridArea: 'location' }} strong>
                  {t('eventHub.inProgress.details.location', 'Location')}
                </Text>
                <Text style={{ gridArea: 'address' }}>{location}</Text>
              </>
            )}
            <Text style={{ gridArea: 'budget' }} strong>
              {t('eventHub.inProgress.details.budget', 'Budget')}
            </Text>
            <Text style={{ gridArea: 'amount' }}>{formatCost(currency, budget)}</Text>
            {attendees && (
              <>
                <Text style={{ gridArea: 'attendees' }} strong>
                  {t('eventHub.inProgress.details.attendees', 'Attendees')}
                </Text>
                <Text style={{ gridArea: 'number' }}>{attendees}</Text>
              </>
            )}
          </div>
          {spaceFacilities.length > 0 && (
            <div style={s.requests}>
              <Text strong>{t('eventHub.inProgress.details.requests', 'Requests')}</Text>
              {spaceFacilities.map(({ name }) => (
                <Tag key={name}>{name}</Tag>
              ))}
            </div>
          )}
          {cateringNeeds && (
            <>
              <Text style={s.header} strong>
                {t('eventHub.inProgress.details.catering', 'Catering')}
              </Text>
              <Paragraph style={s.paragraph}>{cateringNeeds}</Paragraph>
            </>
          )}
          {additionalNotes && (
            <>
              <Text style={s.header} strong>
                {t('eventHub.inProgress.details.addition', 'Additional notes')}
              </Text>
              <Paragraph style={s.paragraph}>{additionalNotes}</Paragraph>
            </>
          )}
        </>
      </ExpandingCard>
    </div>
  )
}
